import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import is from '@sindresorhus/is';

import type { FunctionComponent } from 'react';

type BadgeLabelProps = {
    readonly backgroundColor?: string;
    readonly label: string;
    readonly max?: number;
    readonly textColor?: string;
};

export const InlineBadge: FunctionComponent<BadgeLabelProps> = ({ backgroundColor, label, max, textColor }) => {
    const theme = useTheme();
    const displayValue = is.number(max) && Number(label) > max ? `${max}+` : label;

    return (
        <Typography
            borderRadius={8}
            lineHeight="1.4em"
            px={0.75}
            sx={{
                backgroundColor: backgroundColor ?? theme.palette.primary.main,
                color: textColor ?? theme.palette.primary.contrastText,
            }}
            variant="caption"
        >
            {displayValue}
        </Typography>
    );
};
